import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/background.jpg'
import _imports_1 from './assets/mariya_takeuchi.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7d47032f")

_pushScopeId("data-v-7d47032f")
const _hoisted_1 = { class: "city-pop" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-wrapper" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "background",
    src: _imports_0
  }),
  /*#__PURE__*/_createVNode("div", { class: "artist" }, [
    /*#__PURE__*/_createVNode("h1", { class: "title" }, "Mariya Takeuchi"),
    /*#__PURE__*/_createVNode("h1", { class: "title jp-vertical-text" }, "竹内 まりや"),
    /*#__PURE__*/_createVNode("div", { class: "image-wrapper" }, [
      /*#__PURE__*/_createVNode("img", {
        class: "image",
        src: _imports_1
      }),
      /*#__PURE__*/_createVNode("div", { class: "afterimage offset-4" }),
      /*#__PURE__*/_createVNode("div", { class: "afterimage offset-3" }),
      /*#__PURE__*/_createVNode("div", { class: "afterimage offset-2" }),
      /*#__PURE__*/_createVNode("div", { class: "afterimage offset-1" })
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})